import category from '@/api/category'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  edit_data: {}
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_EDIT_DATA(state, data) {
    state.edit_data = data
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attrubutes
    )
    return category.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return category.store(data)
  },

  update(context, data) {
    return category.update(data)
  },

  restore(context, data) {
    return category.restore(data)
  },
  destroy(context, id) {
    return category.destroy(id)
  },

  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await category.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  }
}
